import {
  Question,
  Screen,
  QuestionType,
  AnswerChoiceGroup,
  AnswerChoice,
  Explanation,
  ExplanationType,
  QuestionPrompt,
  UserAnswer,
  Label,
  QuestionContext,
  QuestionContextType,
  TestExecutionRecord,
} from '../../../data/models'
import { IOperationServiceConfig } from '../../../model-repository'
import { NullOperationService } from '../../../data/services';

// TODO [GitHub Issue]: (enhancement, need to have) Services do not share a common mapper |
// We need to add this config because there is no other way, right now, to register a new model into our system without having
// to create service configs. If services shared mappers, this would not be an issue. Remove once service share a common mapper

export const QuestionOperationConfig: IOperationServiceConfig<Question> = {
  service: NullOperationService,
  deps: [],
  endpoint: 'exams/questions',
  model: Question,
  mappings: [
    {
      classType: 'Question',
      jsonType: 'questions',
      propertyMapping: {
        minorTopics: {
          mapsTo: 'minor-topics',
          isCollection: true
        },
        majorTopic: {
          mapsTo: 'major-topic',
        },
        answerChoiceGroups: {
          isCollection: true
        },
        explanations: {
          isCollection: true
        },
        questionPrompts: {
          isCollection: true
        },
        createdAt: {
          transform: {
            toModel: (value) => new Date(value)
          }
        }
      }
    }
  ]
}

export const ScreenConfig: IOperationServiceConfig<Screen> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: Screen,
  mappings: [{
    classType: 'Screen',
    jsonType: 'screens',
    propertyMapping: {
      config: {
        transform: {
          toModel: (value) => value ? JSON.parse(value) : {},
          toJson: (value) => value ? JSON.stringify(value) : ''
        }
      }
    }
  }],
}

export const QuestionTypeOperationConfig: IOperationServiceConfig<QuestionType> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: QuestionType
}

export const AnswerChoiceGroupOperationConfig: IOperationServiceConfig<AnswerChoiceGroup> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: AnswerChoiceGroup
}

export const AnswerChoiceOperationConfig: IOperationServiceConfig<AnswerChoice> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: AnswerChoice
}

export const ExplanationOperationConfig: IOperationServiceConfig<Explanation> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: Explanation
}

export const ExplanationTypeOperationConfig: IOperationServiceConfig<ExplanationType> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: ExplanationType
}

export const QuestionPromptOperationConfig: IOperationServiceConfig<QuestionPrompt> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: QuestionPrompt
}

export const UserAnswerOperationConfig: IOperationServiceConfig<UserAnswer> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: UserAnswer
}

export const LabelOperationConfig: IOperationServiceConfig<Label> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: Label
}

export const QuestionContextOperationConfig: IOperationServiceConfig<QuestionContext> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: QuestionContext
}

export const QuestionContextTypeOperationConfig: IOperationServiceConfig<QuestionContextType> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: QuestionContextType,
  mappings: [
    {
      classType: 'QuestionContext',
      jsonType: 'question-contexts',
      propertyMapping: {
        'options': {
          isCollection: false,
          transform: {
            toModel: (data) => JSON.parse(data || '{}'),
            toJson: (data) => JSON.stringify(data || {})
          }
        }
      }
    }
  ]
}

export const TestExecutionRecordOperationConfig: IOperationServiceConfig<TestExecutionRecord> = {
  service: NullOperationService,
  deps: [],
  endpoint: '',
  model: TestExecutionRecord,
  mappings: [{
    classType: 'TestExecutionRecord',
    jsonType: 'test-execution-records',
    propertyMapping: {
      'data': {
        transform: {
          toModel: (value) => value ? JSON.parse(value) : {},
          toJson: (value) => value ? JSON.stringify(value) : ''
        }
      }
    }
  }],
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/operation/null.config.ts